'use client'
import updatePoll from '@/travelmde/utilities/updatePoll'
import dynamic from 'next/dynamic'
import { useState } from 'react'

const DynamicPieChart = dynamic(() => import('@/travelmde/components/Common/PieChartComponent'), {
  loading: () => (
    <div className="flex items-center justify-center">
      <div className="flex flex-row items-center space-x-2 animate-pulse">
        <div className="bg-gray-500 h-2 w-2 rounded-full"></div>
        <div className="bg-gray-500 h-2 w-2 rounded-full"></div>
        <div className="bg-gray-500 h-2 w-2 rounded-full"></div>
      </div>
    </div>
  ),
  ssr: false,
})

const ShowPoll = ({ poll, lang, pollResults, pollAnswer }) => {
  const [answerGiven, setAnswerGiven] = useState(null)
  const [newPoll, setNewPoll] = useState(poll)

  const handleAnswerClick = async (answerId) => {
    setAnswerGiven(answerId)
    const answer = poll.answers.find((answer) => answer.id === answerId)
    const updatedPoll = await updatePoll(poll.id, answer, lang)
    setNewPoll(() => updatedPoll)
  }

  // Function to convert index to letter (1=A, 2=B, etc.)
  const indexToLetter = (index) => {
    return String.fromCharCode(64 + index) // 65 is ASCII for 'A'
  }

  const preAnswer = () => {
    return (
      <>
        <p className="ad__text">{poll?.title}</p>
        <ul className="add__datalist ml-4">
          {poll?.answers.map((answer, index) => (
            <li
              key={answer.id}
              onClick={() => handleAnswerClick(answer.id)}
              className="cursor-pointer !flex !flex-row !align-top !items-start"
            >
              <div className="font-bold">{indexToLetter(index + 1)}.</div>
              {answer.answer}{' '}
              <svg
                width="15" // Reduced to a quarter of 47
                height="15" // Reduced to a quarter of 47
                viewBox="0 0 47 47"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="23.2374"
                  cy="23.2372"
                  r="22.4874"
                  transform="rotate(-90 23.2374 23.2372)"
                  stroke="#FE9200"
                  strokeWidth="4" // Changed to camelCase
                ></circle>
                <path
                  d="M13.7514 30.8262C13.2595 31.3107 13.2535 32.1021 13.738 32.594C14.2224 33.0858 15.0139 33.0918 15.5057 32.6074L13.7514 30.8262ZM33.0961 14.7677C33.1013 14.0774 32.5459 13.5135 31.8556 13.5083L20.6059 13.423C19.9156 13.4178 19.3517 13.9732 19.3465 14.6635C19.3412 15.3538 19.8966 15.9177 20.587 15.9229L30.5867 15.9987L30.5109 25.9984C30.5057 26.6888 31.061 27.2526 31.7514 27.2579C32.4417 27.2631 33.0056 26.7077 33.0108 26.0174L33.0961 14.7677ZM15.5057 32.6074L32.7233 15.6488L30.9689 13.8677L13.7514 30.8262L15.5057 32.6074Z"
                  fill="#FE9200"
                ></path>
              </svg>
            </li>
          ))}
        </ul>
      </>
    )
  }

  const postAnswer = () => {
    let pieChartData = {}
    newPoll?.answers.map((answer, index) => {
      pieChartData[`${pollAnswer} ${index + 1}`] = answer.votes
    })

    return (
      <>
        <p className="ad__text">{poll?.title}</p>
        <ul className="add__datalist">
          {newPoll?.answers.map((answer, index) => (
            <li key={answer.id}>
              <span>{indexToLetter(index + 1)}.</span>
              {answer.answer}{' '}
            </li>
          ))}
        </ul>
        <DynamicPieChart pollData={pieChartData} pollResults={pollResults} />
      </>
    )
  }

  return answerGiven ? postAnswer() : preAnswer()
}
export default ShowPoll
